/*  JS of Custom Navigation Menu 
    Added by Wilson from Galadrim  */

// Depth-3 mega menu logic (desktop only)
function openMenus(item, menu, depth3Menus, depth2Items) {
  depth3Menus.forEach(function (m) {
    m.classList.remove("is-active");
  });
  depth2Items.forEach(function (i) {
    i.classList.remove("is-depth3-open");
  });
  if (menu) menu.classList.add("is-active");
  if (item) item.classList.add("is-depth3-open");
  window.activeDepth2 = item;
  window.activeDepth3 = menu;
  window.menuLock = true;
}

function closeMenus(depth3Menus, depth2Items) {
  depth3Menus.forEach(function (menu) {
    menu.classList.remove("is-active");
  });
  depth2Items.forEach(function (i) {
    i.classList.remove("is-depth3-open");
    i.classList.remove("is-active-depth2");
  });
  document.querySelectorAll(".navmenu-depth-1 > li.is-mega-hover").forEach(function (li) {
    li.classList.remove("is-mega-hover");
  });
  window.activeDepth2 = null;
  window.activeDepth3 = null;
  window.menuLock = false;
}

if (window.innerWidth >= 1024) {
  const nav = document.querySelector(".site-navigation");
  if (nav) {
    const depth2Items = nav.querySelectorAll(".navmenu-depth-2 .navmenu-item[data-depth3-id]");
    const depth3Menus = nav.querySelectorAll(".navmenu-depth-3.navmenu-meganav-standard__items");
    let closeTimeout = null;
    let menuHover = false;

    depth2Items.forEach(function (item, idx) {
      const id = item.getAttribute("data-depth3-id");
      const menu = id ? document.getElementById(id) : null;
      const liDepth1 = item.closest(".navmenu-depth-1 > li");

      item.addEventListener("mouseenter", function () {
        menuHover = true;
        if (closeTimeout) clearTimeout(closeTimeout);
        openMenus(item, menu, depth3Menus, depth2Items);
        depth2Items.forEach(function (i) {
          i.classList.remove("is-active-depth2");
        });
        item.classList.add("is-active-depth2");
      });

      item.addEventListener("mouseleave", function () {
        menuHover = false;
        closeTimeout = setTimeout(function () {
          if (!menuHover) closeMenus(depth3Menus, depth2Items);
        }, 300);
      });

      if (menu) {
        menu.addEventListener("mouseenter", function () {
          menuHover = true;
          if (closeTimeout) clearTimeout(closeTimeout);
          menu.classList.add("is-active");
          if (window.activeDepth2) window.activeDepth2.classList.add("is-depth3-open");
          const liDepth1 = window.activeDepth2 ? window.activeDepth2.closest(".navmenu-depth-1 > li") : null;
          if (liDepth1) liDepth1.classList.add("is-mega-hover");
        });
        menu.addEventListener("mouseleave", function () {
          menuHover = false;
          closeTimeout = setTimeout(function () {
            if (!menuHover) {
              menu.classList.remove("is-active");
              if (window.activeDepth2) window.activeDepth2.classList.remove("is-depth3-open");
              const liDepth1 = window.activeDepth2 ? window.activeDepth2.closest(".navmenu-depth-1 > li") : null;
              if (liDepth1) liDepth1.classList.remove("is-mega-hover");
            }
          }, 300);
        });
      }
    });

    nav.addEventListener("mouseleave", function () {
      if (closeTimeout) clearTimeout(closeTimeout);
      window.menuLock = false;
      closeMenus(depth3Menus, depth2Items);
    });
  }
}
